var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"e98960b5b2cce537cec1565a99e6c92e1377eff7"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const ignoredExternalErrors = [
  'ResizeObserver loop limit exceeded',
  'focusOnInputType is not defined',
  "Can't find variable: focusOnInputType",
  'nativeFocusHandler is not defined',
  'appCallbackFuction is not defined',
  'fn_allStopVod is not defined',
  'Invalid call to runtime.sendMessage(). Tab not found.',
  'Object Not Found Matching Id:',
  'Failed to read a named property',
];

function getEventMessage(event) {
  return (
    event?.exception?.values?.[0]?.value ||
    event?.message ||
    event?.logentry?.message ||
    ''
  );
}

function shouldDropExternalEvent(event) {
  const message = getEventMessage(event);
  return ignoredExternalErrors.some((error) => message.includes(error));
}

Sentry.init({
  dsn: SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: process.env.NODE_ENV === 'production',
      dom: false,
    }),
  ],
  ignoreErrors: ignoredExternalErrors,
  beforeSend(event) {
    if (shouldDropExternalEvent(event)) {
      return null;
    }

    return event;
  },
});
